<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <el-button type="primary" class="mr-2"  @click="redirectToPromptLibraries">{{$t('prompt.linkpromptLibraries')}}</el-button>
      <router-link v-if="userRS" :to="{ name: 'new-social-post' }">
        <el-button type="warning">{{$t('posts.list.createPost')}}</el-button>
      </router-link>
    </template>
    <BackButton routeNameToRedirect="calendrier" :content="$t('planning.backToCalendar')" :onButtonClick="resetFilterCalendar"/>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="mt-5">
      <el-tab-pane name="ads">
        <template #label>
              <span>{{$t('planning.postsAds')}}
                <el-badge :value="getPostCountAds" class="ml-2 custom-badge"/>
              </span>
        </template>
        <TableDetailsCalendar :getDataBytab="getDataAds"/>
      </el-tab-pane>
      <el-tab-pane name="bv" v-if="!isVo">
        <template #label>
              <span>{{$t('planning.postsBv')}}
                <el-badge :value="getPostCountBv" class="ml-2 custom-badge"/>
              </span>
        </template>
        <TableDetailsCalendar :getDataBytab="getDataBv"/>
      </el-tab-pane>
      <el-tab-pane name="edito">
        <template #label>
              <span>{{$t('planning.postsEdito')}}
                <el-badge :value="getPostCountEdito" class="ml-2 custom-badge"/>
              </span>
        </template>
        <TableDetailsCalendar :getDataBytab="getDataEdito"/>
      </el-tab-pane>
    </el-tabs>
  </ubi-page-container>
</template>

<script>
import UbiPageContainer from '@/components/PageContainer.vue'
import { TabPane, Tabs } from 'element-ui'
import BackButton from '@/components/ui/BackButton.vue'
import TableDetailsCalendar from '@/pages/calendar/components/TableDetailsCalendar.vue'

export default {
  name: 'CalendarDetails',
  components: {
    TableDetailsCalendar,
    BackButton,
    UbiPageContainer,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  data () {
    return {
      activeName: 'ads'
    }
  },
  computed: {
    userRS () {
      return this.$store.state.app.user.socialNetworkIds
    },
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    isVo () {
      return this.$store.state.app.sitimmoUser.univers === 'VO'
    },
    getDataAds () {
      const ads = this.$store.getters['calendarSocialPosts/getDataAds']
      this.$store.commit('calendarSocialPosts/setPostCountAds', ads.length)
      return ads
    },
    getDataBv () {
      const bv = this.$store.getters['calendarSocialPosts/getDataBv']
      this.$store.commit('calendarSocialPosts/setPostCountBv', bv.length)
      return bv
    },
    getDataEdito () {
      const edito = this.$store.getters['calendarSocialPosts/getDataEdito']
      this.$store.commit('calendarSocialPosts/setPostCountEdito', edito.length)
      return edito
    },
    getPostCountAds () {
      return this.$store.getters['calendarSocialPosts/getPostCountAds']
    },
    getPostCountBv () {
      return this.$store.getters['calendarSocialPosts/getPostCountBv']
    },
    getPostCountEdito () {
      return this.$store.getters['calendarSocialPosts/getPostCountEdito']
    },
  },
  methods: {
    handleClick (tab, event) {
      switch (tab.name) {
        case 'ads':
          this.$store.commit('calendarSocialPosts/setFilters', { key: 'typePost', value: this.sitimmoUser.univers })
          this.$store.dispatch('calendarSocialPosts/loadEventsForOneDayByTypePost', { date: this.$route.params.date })
          break
        case 'bv':
          this.$store.commit('calendarSocialPosts/setFilters', { key: 'typePost', value: `${this.sitimmoUser.univers}_BIENS_VENDUS` })
          this.$store.dispatch('calendarSocialPosts/loadEventsForOneDayByTypePost', { date: this.$route.params.date })
          break
        case 'edito':
          this.$store.commit('calendarSocialPosts/setFilters', { key: 'typePost', value: 'EDITO' })
          this.$store.dispatch('calendarSocialPosts/loadEventsForOneDayByTypePost', { date: this.$route.params.date })
          break
      }
    },
    resetFilterCalendar () {
      this.$store.commit('calendarSocialPosts/resetFilters')
    },
    redirectToPromptLibraries () {
      this.$router.replace('/prompt-libraries?action=create')
    }
  },
  mounted () {
    this.$store.commit('calendarSocialPosts/setFilters', { key: 'typePost', value: this.sitimmoUser.univers })
    this.$store.dispatch('calendarSocialPosts/loadEventsForOneDayByTypePost', { date: this.$route.params.date })
  }
}
</script>

<style>
.custom-badge .el-badge__content {
  background-color: #00a4bd!important; /* Custom background color */
  color: white!important; /* Custom text color */
}
</style>
